import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import {
    ITransaction,
    ITransactionStat,
    ODataResponse,
} from '@models';
import { aggregateTransactionData } from '@pages/shared/chart.config';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { map } from 'rxjs/operators';

@Injectable()
export class TransactionService extends ODataService<ITransaction, number> {
    protected _endpoint: string;
    constructor(
        http: HttpClient,
        private _appState: AppStateFacade,
    ) {
        super(http, MapperService.transactionMap);
        this._endpoint = `${
            this._appState.authConfig.odataBaseUrl
            }/QueueProcessingRecords/UiPathODataSvc.RetrieveQueuesProcessingStatus`;
    }

    public getTransactionStats(daysNo: number, queueDefId: number) {
        const endpoint = `UiPathODataSvc.RetrieveLastDaysProcessingRecords(daysNo=${daysNo},queueDefinitionId=${queueDefId})`;
        return this._http.get(`${this._appState.authConfig.odataBaseUrl}/QueueProcessingRecords/${endpoint}`)
            .pipe(
                map(res => {
                    const mapped = this._mapData(res, MapperService.transactionStatsMap) as ODataResponse<ITransactionStat>;
                    return aggregateTransactionData(mapped.data);
                }),
            );
    }
}
